/** Reads a query param by name, ignoring parameter name casing (e.g. UTM_Source, utm_source). */
export const getSearchParamCaseInsensitive = (
    searchParams: URLSearchParams,
    name: string
): string | null => {
    const target = name.toLowerCase();
    let match: string | null = null;
    searchParams.forEach((value, key) => {
        if (match === null && key.toLowerCase() === target) {
            match = value;
        }
    });
    return match;
};



// WEBPACK FOOTER //
// ./src/utilities/sourceParams.ts